module.exports = __webpack_public_path__ + "static/section1-fg2-6e3ce7223556c784233c32129c7a5613.png";